import styled from 'styled-components'

export const ReceiptModalContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 85px calc(100vw - 40px) 58px;
  grid-gap: 25px;
  height: 100%;
  margin-top: 12px;
  h2 {
    font-weight: 600;
    font-size: 17px;
    line-height: 20px;
    padding-bottom: 9px;
    margin: 0;
  }
  p {
    font-size: 11px !important;
    line-height: 15px;
    display: flex;
    align-items: center;
    color: #434343;
  }
  &::after {
    content: unset;
  }
`

//

export const ReceiptInput = styled.input`
  border: 0px;
  border-bottom: 1px solid ${({ theme }) => theme.colour};

  outline: none;
  height: 18vw;
  width: 100%;
  text-align: center;
  font-size: 8vw;
  color: ${({ theme }) => theme.FontColor};
  background-color: ${({ theme }) => theme.MainBackGround};
`

// No-Receipt styles

export const MessageContainerNoReceipt = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  h2 {
    color: ${({ theme }) => theme.FontColor};
    font-size: 20px;
    font-weight: 400;
    margin-top: 15px;
    text-align: center;
  }
`

export const ButtonContainer = styled.div`
  grid-column: 1 / -1;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 5vw;
`

export const ReceiptLoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  height: 100%;

  h2 {
    color: ${({ theme }) => theme.FontColor};
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    margin-top: 50px;
  }
`
